import { render, staticRenderFns } from "./legacy-panel.vue?vue&type=template&id=384eca78&scoped=true"
var script = {}
import style0 from "./legacy-panel.vue?vue&type=style&index=0&id=384eca78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384eca78",
  null
  
)

export default component.exports